export const DEFAULT_EMAIL_VERIFICATION_ERROR = "Podaj poprawny adres e-mail";
export const VERIFICATION_API_DEFAULT_ERROR = "Weryfikacja adresu e-mail nie powiodła się, proszę spróbować póżniej";
export const VERIFICATION_API_UNEXPECTED_ERROR = "Wystąpił nieoczekiwany błąd, proszę spróbować póżniej";
export const DEFAULT_EMAIL_VERIFICATION_ERROR = "Podaj poprawny adres e-mail";
export const VERIFICATION_API_DEFAULT_ERROR = "Weryfikacja adresu e-mail nie powiodła się, proszę spróbować póżniej";
export const VERIFICATION_API_UNEXPECTED_ERROR = "Wystąpił nieoczekiwany błąd, proszę spróbować póżniej";
